export default __webpack_public_path__ + "static/media/Stones02.3de8cacb.png";